import * as React from 'react'
// libs
import { isValid } from 'redux-form'
import { useSelector } from 'react-redux'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// context
import { SubPlanStepperAPIContext } from 'containers/SubPlan/layers/API'
import { SubPlanStepperBLContext } from 'containers/SubPlan/layers/BL/Stepper'
// constants
import { Forms } from 'constants/index'
// views
import { ButtonWrapper, BUTTON_STYLE } from 'components/Modals/CreateSubPlanModal/SubPlanStepper/view'

const StepperButtons: React.FC = () => {
  const { createdPlan, parentPlan, steps } = React.useContext(SubPlanStepperAPIContext)
  const { activeStep, handleNextClick, handleCancelClick, handlePreviousClick } =
    React.useContext(SubPlanStepperBLContext)

  const { isFormValid } = useSelector((state) => ({
    isFormValid: isValid(Forms.CREATE_SUB_PLAN_FORM)(state)
  }))

  const buttonLabel = React.useMemo(() => {
    if (activeStep === 0 && !createdPlan) {
      return 'Create'
    }
    if (activeStep !== steps.length && createdPlan) {
      return 'Next'
    }
    if (activeStep === steps.length) {
      return 'View Plan'
    }
  }, [activeStep, createdPlan])

  return (
    <ButtonWrapper>
      {activeStep > 0 && (
        <Button layout={BUTTON_LAYOUTS.WHITE} onClick={handlePreviousClick} style={BUTTON_STYLE}>
          Previous
        </Button>
      )}
      <Button
        type={'submit'}
        layout={BUTTON_LAYOUTS.PURPLE}
        onClick={handleNextClick}
        style={BUTTON_STYLE}
        disabled={!isFormValid}>
        {buttonLabel}
      </Button>
      <Button
        type={'submit'}
        layout={BUTTON_LAYOUTS.WHITE}
        onClick={handleCancelClick(parentPlan)}
        style={BUTTON_STYLE}>
        Close
      </Button>
    </ButtonWrapper>
  )
}

export default StepperButtons
